import { saveAs } from "file-saver";
import exceljs from "exceljs";
//--------------------------------------------------------------------------------------------
import { useMyStore } from "src/components/main/mainStore";
import {
    mimeTypeMap, 
    MyDate, 
} from "src/components/common/functions";
export default function Export({
    filteredPerDiems
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const exportFunc = () => {
        if(!filteredPerDiems.length){
            window.alert("No data to export.");
            return;
        }
        setShowLoader(true);
        const workbook = new exceljs.Workbook();
        workbook.creator = user.userName;
        workbook.created = new Date();
        workbook.calcProperties.fullCalcOnLoad = true;
        const worksheet = workbook.addWorksheet("My Sheet", {views: [{showGridLines: false}]});
        worksheet.state = "visible";
        worksheet.properties.defaultColWidth = 22.57
        const rows = filteredPerDiems.map(post => [
                post.requester,
                post.requestDates, 
                post.totalHours,
                post.type, 
                post.notes,
                post.creator,
                post.submitTime,
                post.dateUpdated ?? "",
                post.approver,
                post.notify ?? "",  
                post.status,
                post.paid,
                post.reviewTime,
                post.approverNotes,
        ])
        //--------------------------------------------------------------------------------------------------------
        worksheet.addTable({
            name: "MyTable",
            ref: "A1",
            style: {
                showRowStripes: true,
            },
            columns: [
                { name: "Requester", filterButton: true},
                { name: "Request Dates", filterButton: true},
                { name: "Total Hours", filterButton: true},
                { name: "Type", filterButton: true},
                { name: "Notes", filterButton: true},
                { name: "Submitter", filterButton: true},
                { name: "Date Created", filterButton: true},
                { name: "Date Updated", filterButton: true},
                { name: "Approver", filterButton: true},
                { name: "Notified At", filterButton: true},
                { name: "Status", filterButton: true},
                { name: "Paid", filterButton: true},
                { name: "Review Time", filterButton: true},
                { name: "Approver Comments", filterButton: true},
            ],
            rows: rows,
        });
        //--------------------------------------------------------------------------------------------------------
        worksheet.columns.forEach(column => {
            const minLength = 18;
            let maxLength = 0;
            column["eachCell"]({ includeEmpty: true }, cell => {
                const columnLength = cell.value?
                cell.value.toString().length * (cell.font?cell.font.size / 11 * 1.2:1.1)
                :minLength;
                if(columnLength > maxLength){
                    maxLength = columnLength;
                }
            });
            column.width = maxLength < minLength ? minLength : maxLength;
        });
        //--------------------------------------------------------------------------------------------------------
        for(let rowIndex = 2; rowIndex <= worksheet.rowCount; rowIndex++){
            worksheet.getRow(rowIndex).alignment = { vertical: "middle", horizontal: "center"};
        }
        worksheet.getColumn(2/*#*/).alignment = { horizontal: "center", wrapText: true };
        worksheet.getColumn(2/*#*/).width = 30/*#*/;
        //--------------------------------------------------------------------------------------------------------
        workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], { type: mimeTypeMap.xlsx }), `perdiem export ${(new MyDate()).s()}.xlsx`);
            setShowLoader(false);
        })
    }
    return (
        <button type = "button" className = "headerButton" onClick = {exportFunc}>Export</button>
    )
}